// ** UI
import Box from '@mui/material/Box';

// ** Types
import type { SxProps, Theme } from '@mui/material/styles';

export type DividerProps = {
	/**
	 * CSS color used for the line.
	 * Defaults to the same subtle grey used across the UI.
	 */
	color?: string;
	/**
	 * Line thickness. Number values are treated as pixels.
	 */
	thickness?: number | string;
	/**
	 * Optional additional styles.
	 */
	sx?: SxProps<Theme>;
};

const Divider = ({ color = 'rgba(0, 0, 0, 0.18)', thickness = 1, sx }: DividerProps) => {
	const height = typeof thickness === 'number' ? `${thickness}px` : thickness;

	return (
		<Box
			aria-hidden
			role="separator"
			sx={[
				{
					width: '100%',
					height,
					backgroundColor: color,
					flexShrink: 0
				},
				...(Array.isArray(sx) ? sx : sx ? [sx] : [])
			]}
		/>
	);
};

export default Divider;
